import { defineComponent as _defineComponent } from 'vue'
import { DrawdownQuotePriceResponse, QuotePriceResponse } from 'ah-api-gateways';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TradePriceExchangeRate',
  props: {
    tradePriceResponse: null
  },
  setup(__props: any) {

const props = __props as {
  /**
   * Trade price response object
   */
  tradePriceResponse: QuotePriceResponse | DrawdownQuotePriceResponse;
};



const primaryRate = computed(() => {
  return props.tradePriceResponse.ccy1.isPrimaryRate ? props.tradePriceResponse.ccy1 : props.tradePriceResponse.ccy2;
});

const secondaryRate = computed(() => {
  return props.tradePriceResponse.ccy1.isPrimaryRate ? props.tradePriceResponse.ccy2 : props.tradePriceResponse.ccy1;
});

return { __sfc: true,props, primaryRate, secondaryRate }
}

})